import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-218d8176")

_pushScopeId("data-v-218d8176")
const _hoisted_1 = { class: "row animated fadeIn" }
const _hoisted_2 = { class: "col-xl-12 col-lg-12" }
const _hoisted_3 = { class: "card border-left-danger shadow mb-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "card-header py-3 d-flex flex-row align-items-center justify-content-between" }, [
  /*#__PURE__*/_createVNode("h6", { class: "m-0 font-weight-bold" }, " Pending Manual Orders ")
], -1)
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-lg-7 col-md-7 col-sm-12 col-12" }
const _hoisted_9 = { class: "custom-input-group mb-3" }
const _hoisted_10 = {
  key: 0,
  class: "input-group-text",
  style: {"border-top-left-radius":"0","border-bottom-left-radius":"0","border-left-width":"0"}
}
const _hoisted_11 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"
  })
], -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M22,3H7C6.31,3 5.77,3.35 5.41,3.88L0,12L5.41,20.11C5.77,20.64 6.31,21 7,21H22A2,2 0 0,0 24,19V5A2,2 0 0,0 22,3M19,15.59L17.59,17L14,13.41L10.41,17L9,15.59L12.59,12L9,8.41L10.41,7L14,10.59L17.59,7L19,8.41L15.41,12"
  })
], -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" No pending orders. ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Loading pending orders data. Please wait. ")
const _hoisted_15 = { style: {"display":"block","width":"140px"} }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { class: "d-flex justify-content-around" }
const _hoisted_21 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn btn-sm btn-primary"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-pen" })
], -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn btn-sm btn-info"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-search" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Column = _resolveComponent("Column")
  const _component_IconsCurrency = _resolveComponent("IconsCurrency")
  const _component_router_link = _resolveComponent("router-link")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", null, [
              _createVNode(_component_DataTable, {
                value: _ctx.orders,
                paginator: true,
                rows: 10,
                rowsPerPageOptions: [10, 20, 50],
                autoLayout: true,
                filterDisplay: "menu",
                loading: _ctx.status == 'fetching',
                paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
                currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}",
                filters: _ctx.filters,
                "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters = $event)),
                globalFilterFields: [
                  'customer.fullName',
                  'pairId',
                  'createdAt'
                ]
              }, {
                header: _withId(() => [
                  _createVNode("div", _hoisted_7, [
                    _createVNode("div", _hoisted_8, [
                      _createVNode("div", _hoisted_9, [
                        _withDirectives(_createVNode("input", {
                          autofocus: "",
                          type: "text",
                          class: "form-control",
                          placeholder: "Type to search...",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.filters['global'].value]
                        ]),
                        (!_ctx.filters['global'].value)
                          ? (_openBlock(), _createBlock("span", _hoisted_10, [
                              _hoisted_11
                            ]))
                          : (_openBlock(), _createBlock("span", {
                              key: 1,
                              class: "input-group-text",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clearFilter()))
                            }, [
                              _hoisted_12
                            ]))
                      ])
                    ])
                  ])
                ]),
                empty: _withId(() => [
                  _hoisted_13
                ]),
                loading: _withId(() => [
                  _hoisted_14
                ]),
                default: _withId(() => [
                  _createVNode(_component_Column, {
                    field: "customerFullname",
                    header: "User",
                    bodyStyle: "text-align: left"
                  }, {
                    body: _withId((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.data.customer.firstName) + " " + _toDisplayString(slotProps.data.customer.lastName), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "amount",
                    header: "Amount",
                    headerStyle: "text-align: right",
                    bodyStyle: "text-align: right"
                  }, {
                    body: _withId((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.formatZeros(
                        slotProps.data.amount,
                        slotProps.data.pair.baseCurrency.exact
                      )), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "pair",
                    header: "Pair",
                    headerStyle: "text-align: center",
                    bodyStyle: "text-align: center"
                  }, {
                    body: _withId((slotProps) => [
                      _createVNode("span", _hoisted_15, [
                        _createTextVNode(_toDisplayString(slotProps.data.pairId) + " ", 1),
                        (_ctx.getStatusCurrenciesSatstreet == 'success')
                          ? (_openBlock(), _createBlock("span", _hoisted_16, [
                              (
                            _ctx.splitPair(slotProps.data.pairId).pairType == 'mix'
                          )
                                ? (_openBlock(), _createBlock("span", _hoisted_17, [
                                    _createVNode(_component_IconsCurrency, {
                                      pairType: 
                              _ctx.splitPair(slotProps.data.pairId).pairType
                            ,
                                      localCurrency: 
                              _ctx.splitPair(slotProps.data.pairId).fiat.first
                            ,
                                      cryptoCurrency: 
                              _ctx.splitPair(slotProps.data.pairId).crypto.first
                            ,
                                      reverse: slotProps.data.side !== 1 ? true : false,
                                      color: true,
                                      width: '20',
                                      height: '20'
                                    }, null, 8, ["pairType", "localCurrency", "cryptoCurrency", "reverse"])
                                  ]))
                                : _createCommentVNode("", true),
                              (
                            _ctx.splitPair(slotProps.data.pairId).pairType ==
                              'crypto'
                          )
                                ? (_openBlock(), _createBlock("span", _hoisted_18, [
                                    _createVNode(_component_IconsCurrency, {
                                      pairType: 
                              _ctx.splitPair(slotProps.data.pairId).pairType
                            ,
                                      localCurrency: 
                              _ctx.splitPair(slotProps.data.pairId).crypto.second
                            ,
                                      cryptoCurrency: 
                              _ctx.splitPair(slotProps.data.pairId).crypto.first
                            ,
                                      reverse: slotProps.data.side !== 1 ? true : false,
                                      color: true,
                                      width: '20',
                                      height: '20'
                                    }, null, 8, ["pairType", "localCurrency", "cryptoCurrency", "reverse"])
                                  ]))
                                : _createCommentVNode("", true),
                              (
                            _ctx.splitPair(slotProps.data.pairId).pairType == 'fiat'
                          )
                                ? (_openBlock(), _createBlock("span", _hoisted_19, [
                                    _createVNode(_component_IconsCurrency, {
                                      pairType: 
                              _ctx.splitPair(slotProps.data.pairId).pairType
                            ,
                                      localCurrency: 
                              _ctx.splitPair(slotProps.data.pairId).fiat.second
                            ,
                                      cryptoCurrency: 
                              _ctx.splitPair(slotProps.data.pairId).fiat.first
                            ,
                                      reverse: slotProps.data.side !== 1 ? true : false,
                                      color: true,
                                      width: '20',
                                      height: '20'
                                    }, null, 8, ["pairType", "localCurrency", "cryptoCurrency", "reverse"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "side",
                    header: "Side"
                  }, {
                    body: _withId((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.data.side == 1 ? 'BUY' : 'SELL'), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    header: "Filled",
                    headerStyle: "text-align: right",
                    bodyStyle: "text-align: right"
                  }, {
                    body: _withId((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.formatZeros(
                        slotProps.data.totalFilled,
                        slotProps.data.pair.baseCurrency.exact
                      )), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    header: "Pending",
                    headerStyle: "text-align: right",
                    bodyStyle: "text-align: right"
                  }, {
                    body: _withId((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.formatZeros(
                        slotProps.data.pending,
                        slotProps.data.pair.baseCurrency.exact
                      )), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "amount",
                    header: "Filling orders",
                    headerStyle: "text-align: right",
                    bodyStyle: "text-align: right"
                  }, {
                    body: _withId((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.data.providerOrders.length), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "createdAt",
                    header: "Created At"
                  }, {
                    body: _withId((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.formatDate(slotProps.data.createdAt)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "quantity",
                    header: "Action",
                    headerStyle: "text-align:center"
                  }, {
                    body: _withId((slotProps) => [
                      _createVNode("div", _hoisted_20, [
                        _createVNode(_component_router_link, {
                          to: {
                          name: 'on-behalf-of.home.edit-manual.order',
                          params: {
                            customerId: slotProps.data.customer.id,
                            orderId: slotProps.data.uuid
                          }
                        }
                        }, {
                          default: _withId(() => [
                            _hoisted_21
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        _createVNode(_component_router_link, {
                          to: {
                          name: 'dashboard.order-details',
                          params: { id: slotProps.data.uuid }
                        }
                        }, {
                          default: _withId(() => [
                            _hoisted_22
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value", "loading", "filters", "globalFilterFields"])
            ])
          ])
        ])
      ])
    ])
  ]))
})